import { createSlice } from "@reduxjs/toolkit";

export const name = "cdr";

export const cdrSlice = createSlice({
  name,
  initialState: {
    cleanFileId: "",
    cleanFileLoading: false,
    showCleanFileInfo: true,
  },
  reducers: {
    RequestCleanFile: (state, action) => {
      state.cleanFileId = action.payload.fileId;
      state.showCleanFileInfo = false;
      state.cleanFileLoading = true;
    },
    SuccessCleanFile: (state) => {
      state.showCleanFileInfo = true;
      state.cleanFileLoading = false;
    },
    FailureCleanFile: (state) => {
      state.cleanFileId = "";
      state.showCleanFileInfo = false;
      state.cleanFileLoading = false;
    },
    ClearCleanFileId: (state) => {
      state.cleanFileId = "";
    },
  },
});

export default cdrSlice;
